import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { DimensionFormTypes } from "models/formTypes";
import { SplitPresetsAddFormContainerProps } from "models/propTypes/dimensionPropTypes";
//#endregion
//#region components
import SplitPresetsAddForm from "./splitPresetsAddForm";
import { useDimensionService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const SplitPresetsAddFormContainer: ForwardRefRenderFunction<FormHandles, SplitPresetsAddFormContainerProps> = (
  props,
  ref
) => {
  const dimensionService = useDimensionService();
  const validationSchema = Yup.object<DimensionFormTypes.SplitPresets>({
    subject: Yup.string()
      .required(TranslationKeys.Validations.Required)
      .notOneOf(
        props.presets.map((p) => p.text),
        TranslationKeys.Validations.AlreadyExists
      ),
  });

  const defaultValues = {
    subject: "",
  } as DimensionFormTypes.SplitPresets;

  const handleSubmit = (values: DimensionFormTypes.SplitPresets) => {
    const presetPost = { ...props.preset, text: values.subject };
    return dimensionService.savePreset(presetPost, props.dimensionPresetType, props.dimensionType).then((res) => {
      presetPost.id = res.data;
      props.onFormSubmitted(presetPost);
    });
  };

  return (
    <SplitPresetsAddForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
      onFormValidationChange={props.onFormValidationChange}
    />
  );
};

export default forwardRef(SplitPresetsAddFormContainer);
